import React from 'react'
import services from './service.json'
import './services.css'
const Services = () => {
  return (
    <div id='Services'>
      <h1 className='heading'>SERVICES</h1>
      <div id='serve' className='servicess'>
        {services.map((service,index)=>{
            return <div key={index} className='service'>
                <h2>{service.ID}</h2>
                <h2>{service.Name}</h2>
                <p>{service.Description}</p>
            </div>
        })}
      </div>
    </div>
  )
}

export default Services
